export interface UserCapabilitiesApiResponse {
    message?: string,
    error?: string,
    data?: string[]
}

export enum Capability {
    CAP_FLEETAPP_VIEW_DEFECTS = 'CAP_FLEETAPP_VIEW_DEFECTS',
    CAP_FLEETAPP_VIEW_FLEETS = 'CAP_FLEETAPP_VIEW_FLEETS',
    CAP_FLEETAPP_VIEW_GRADES = 'CAP_FLEETAPP_VIEW_GRADES',
    CAP_FLEETAPP_VIEW_SUBGRADES = 'CAP_FLEETAPP_VIEW_SUBGRADES',
    CAP_FLEETAPP_VIEW_RECTIFICATIONS = 'CAP_FLEETAPP_VIEW_RECTIFICATIONS',
    CAP_FLEETAPP_NOTIFICATIONS = 'CAP_FLEETAPP_NOTIFICATIONS',
    CAP_FLEETAPP_VIEW_PSC = 'CAP_FLEETAPP_VIEW_PSC',
    CAP_FLEETAPP_VIEW_SCREENING = 'CAP_FLEETAPP_VIEW_SCREENING',
    CAP_FLEETAPP_DASHBOARD = 'CAP_FLEETAPP_DASHBOARD',
    CAP_FLEETAPP_ASK_IDWAL_AI = 'CAP_FLEETAPP_ASK_IDWAL_AI'
}
